// A keyboard shortcut set as keys in words (UX spec 10): nested <kbd> for each combination, "or"
// between alternatives. Never key or arrow glyphs.
import { Fragment } from 'react';
import { type Combo, type Platform, keyLabel } from '../lib/shortcuts.ts';

export function Keys({ keys, platform }: { keys: readonly Combo[]; platform: Platform }) {
  return (
    <span className="keys">
      {keys.map((combo, i) => (
        <Fragment key={combo.join('+')}>
          {i > 0 ? <span className="keys-join">or</span> : null}
          <kbd className="keys-combo">
            {combo.map((key, j) => (
              <Fragment key={key}>
                {j > 0 ? <span className="keys-join">+</span> : null}
                <kbd className="kbd">{keyLabel(key, platform)}</kbd>
              </Fragment>
            ))}
          </kbd>
        </Fragment>
      ))}
    </span>
  );
}
